<textarea [disabled]="review" #textAreaElement [(ngModel)]="answer" placeholder="Write your answer here..." class="input w-full mt-2" rows="10">
</textarea>
